import { render } from "./FatPickr.vue?vue&type=template&id=49a3d88e&scoped=true"
import script from "./FatPickr.vue?vue&type=script&lang=js"
export * from "./FatPickr.vue?vue&type=script&lang=js"

import "./FatPickr.vue?vue&type=style&index=0&id=49a3d88e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a3d88e"]])

export default __exports__